import React, { useState } from 'react';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { withTimer, withSession } from 'chameleon/ui-stack/hocs/player';
import TimedAssignmentWarningModal from 'chameleon/ui-stack/ui/assignments/timed-assignment-warning-modal';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import { isImpersonating } from 'legacy-src/components/impersonating/utils';

const withImpersonating = (WrappedComponent) => (props) => {
  return <WrappedComponent {...props} isImpersonating={isImpersonating()} />;
};

const TimedAssignmentWrapper = (WrappedComponent) => {
  const TimedAssignmentInnerWrapper = (props) => {
    const {
      location: { state = {} },
      params,
      router,
      isAssignmentSessionLoading,
      timerInfo,
      isAssignmentTimerLoading,
      assignmentTimerData = {},
      checkCBSessionFlag,
    } = props;
    const { timeElapsed = 0, totalTime = 0 } = timerInfo || {};
    const { timer } = assignmentTimerData;
    const { subject } = params;
    const { returnPath } = state;
    const canCheckAssignment = checkCBSessionFlag && !!!returnPath;
    const [showPlayer, setShowPlayer] = useState(false);
    const isLoading = isAssignmentSessionLoading || isAssignmentTimerLoading;

    if (!canCheckAssignment) {
      return <WrappedComponent {...props} />;
    }

    const onModalSuccess = () => {
      setShowPlayer(true);
    };

    const onModalClose = () => {
      router.replace(`/${subject}/assignments`);
    };

    if (canCheckAssignment && isLoading) {
      return <LoadingSpinner />;
    } else if (
      canCheckAssignment &&
      !isLoading &&
      timer > 0 &&
      (!timerInfo || (timeElapsed === 0 && totalTime > 0)) &&
      !showPlayer
    ) {
      return (
        <TimedAssignmentWarningModal
          onSuccess={onModalSuccess}
          onClose={onModalClose}
          timer={timer}
        />
      );
    }

    return <WrappedComponent {...props} />;
  };

  const mapStateToProps = (state) => {
    const { featureFlag } = state;
    return {
      checkCBSessionFlag:
        featureFlag.cb_session_expiration_check_before_take_assignment,
    };
  };

  return compose(
    connect(mapStateToProps),
    withImpersonating,
    withTimer,
    withSession,
  )(TimedAssignmentInnerWrapper);
};

export default TimedAssignmentWrapper;
